import React, { PropsWithChildren, ReactElement } from "react";
import { ReactComponent as ArrowRightIcon } from "../../../resources/icons/Property 1=front.svg";

interface Props extends PropsWithChildren {
    icon?: ReactElement;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    size?: "l" | "m" | "s";
    theme?: "primary" | "secondary" | "tertiary";
    iconRight?: boolean;
    ref: React.Ref<any>;
}

export const Button = React.forwardRef<HTMLButtonElement, Props>(
    (
        {
            children,
            icon,
            disabled = false,
            onClick,
            iconRight = false,
            size = "m",
            theme = "primary"
        },
        ref
    ) => {
        const sizeStyle = SizeStyle(size, iconRight);
        const colorStyle = ColorStyle(theme, iconRight);
        const iconStyle = IconStyle(theme, disabled);
        const iconSize = IconSize(size);

        icon = icon ? (
            React.cloneElement(icon, {
                className: `${icon.props.className} ${iconStyle} ${iconSize}`
            })
        ) : (
            <ArrowRightIcon className={`${iconStyle} ${iconSize}`} />
        );

        return (
            // @ts-ignore
            <button
                ref={ref}
                className={`flex items-center duration-150 transition-colors justify-center ${sizeStyle} ${colorStyle} min-w-[120px]`}
                disabled={disabled}
                onClick={onClick}
            >
                <span>{children}</span>
                {iconRight && <span className={"pl-12"}>{icon}</span>}
            </button>
        );
    }
);

export function SizeStyle(size: "l" | "m" | "s", iconRight: boolean) {
    let height;
    let padding;
    let textSize;
    switch (size) {
        case "l":
            height = "h-60";
            padding = iconRight ? "pl-24 pr-20" : "px-24";
            textSize = "text-n";
            break;
        case "m":
            height = "h-44";
            padding = iconRight ? "pl-24 pr-20" : "px-24";
            textSize = "text-n";
            break;
        case "s":
            height = "h-28";
            padding = "px-12";
            textSize = "text-xs";
            break;
    }

    return `${height} ${padding} ${textSize}`;
}

export function ColorStyle(
    theme: "primary" | "secondary" | "tertiary",
    disabled: boolean
) {
    let bg;
    let border;
    let text;
    const cursor = "disabled:cursor-not-allowed cursor-pointer";
    switch (theme) {
        case "primary":
            bg =
                "disabled:bg-system-gray-light disabled:hover:!bg-system-gray-light disabled:text-secondary-gray-light bg-secondary-green-light hover:bg-secondary-green text-white";
            text = "disabled:text-secondary-gray-light text-white";
            border = "";
            break;
        case "secondary":
            bg =
                " " +
                "disabled:hover:!bg-system-white " +
                "bg-system-white " +
                "hover:bg-secondary-blue-lightest ";
            text =
                "disabled:text-secondary-gray-light text-primary-identity-Blue";
            border =
                "border disabled:border-system-gray-light border-primary-identity-Blue";
            break;
        case "tertiary":
            bg =
                " " +
                "disabled:hover:!bg-system-gray-light " +
                "bg-transparent " +
                "hover:bg-secondary-blue-lightest ";
            text =
                "disabled:text-secondary-gray-light text-primary-identity-Blue";
            border = "";
            break;
    }

    return `${cursor} ${bg} ${border} ${text}`;
}

function IconStyle(
    theme: "primary" | "secondary" | "tertiary",
    disabled: boolean
) {
    if (disabled) {
        return " svg-white-disabled ";
    }
    switch (theme) {
        case "primary":
            return " svg-white ";
        case "secondary":
        case "tertiary":
            return " svg-primary-blue ";
    }
}

function IconSize(size: "l" | "m" | "s") {
    switch (size) {
        case "l":
        case "m":
            return "h-24 w-24";
        case "s":
            return "h-20 w-20";
    }
}
